<template>
  <div class="vl-person-manage">
    <!--面包屑-->
    <div class="pm-bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'personDefault' }"
          >个人中心</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ name: 'personDefault' }"
          >我的应用</el-breadcrumb-item
        >
        <el-breadcrumb-item>应用管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <ul class="menuUl">
      <div class="company">
        <img :src="appDetail.appLogo" alt="" width="104px" height="104px" />
        <div class="name">{{ appDetail.appName || "" }}</div>
        <div class="email">
          {{ appDetail.appTypeName || "" }}｜{{
            appDetail.appTerminalTypeName || ""
          }}
        </div>
      </div>
      <el-menu ref="sideNav" active-text-color="#4286F5" text-color="#333333">
        <el-menu-item
          :index="item.name"
          v-for="(item, index) in menuList"
          @click="goPage(item)"
          :key="'app-manage' + index"
        >
          <span slot="title">
            <i
              class="iconfont"
              :class="item.icon"
              style="
                vertical-align: baseline;
                font-size: 20px;
                margin-right: 5px;
              "
            ></i>
            {{ item.title }}
          </span>
        </el-menu-item>
      </el-menu>
    </ul>
    <div class="tableCont">
      <router-view :appDataInfo="this.appDetail"></router-view>
    </div>
  </div>
</template>
<script>
import { PersonalPostAppInfoById } from "@/views/index/api/personalCenter/api.personalCenter.js";

const menuList = [
  {
    title: "开发配置",
    name: "appManegeAppConfig",
    icon: "icon-kfpz",
  },
  {
    title: "应用详情",
    name: "appManegeAppDetail",
    icon: "icon-Leftsidebar_Applicationdetails",
  },
  {
    title: "接口订阅",
    name: "appManegeAppInterface",
    icon: "icon-Leftsidebar_Interfacesubscription",
  },
  {
    title: "标准数据",
    name: "appManegeAppDataInterface",
    icon: "icon-Leftsidebar_Interfacesubscription",
  },
  {
    title: "应用评分",
    name: "appManegeAppScoringApplication",
    icon: "icon-Leftsidebar_Interfacesubscription",
  },
  {
    title: "开通查询",
    name: "appManegeAppOpenSearch",
    icon: "icon-Leftsidebar_Openquery",
  },
];

export default {
  data() {
    return {
      appId: "",
      appDetail: {},
      menuList: menuList,
    };
  },
  mounted() {
    this.appId = this.$route.query.appId;
    this.getAppDetails();
    this.$refs.sideNav.activeIndex = this.$route.name;
  },
  methods: {
    goPage(item) {
      this.$router.push({ name: item.name, query: { appId: this.appId } });
    },
    getAppDetails() {
      let params = {
        appId: this.appId,
      };
      PersonalPostAppInfoById(params).then((res) => {
        if (res && res.result) {
          this.appDetail = res.result;
          if (this.appDetail.appStatus == "app_status_8") {
            this.menuList = menuList;
          } else {
            this.menuList = menuList.filter(item => item.name !== "appManegeAppOpenSearch");
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.vl-person-manage {
  display: flex;
  position: relative;
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  padding-top: 50px;
  min-height: 857px;
  .pm-bread {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    @include setColor("background-color", "chunk_3");
    display: flex;
    align-items: center;
  }
  .tableCont {
    width: calc(100% - 250px);
    padding: 40px 40px 50px;
    border: 1px solid #ebeef5;
    border-left: none;
  }
  .menuUl {
    width: 250px;
    /* box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.1); */
    border: 1px solid #ebeef5;
  }
  .menuUl > .company {
    /* height: 230px; */
    background: url(../../../../../assets/img/menuBg.png) no-repeat center;
    background-size: 100% 100%;
    text-align: center;
  }
  .menuUl > .company > img {
    display: inline-block;
    margin: 40px 0 20px 0;
  }
  .menuUl > .company > div {
    text-align: center;
  }
  .menuUl > .company > .name {
    font-size: 18px;
    color: #0059b2;
    font-weight: bold;
  }
  .menuUl > .company > .email {
    font-size: 16px;
    color: #333;
    padding-top: 10px;
    padding-bottom: 15px;
  }
  .menuUl .el-menu {
    border-right: none !important;
  }
  .menuUl .el-menu-item {
    font-size: 18px !important;
    height: 50px !important;
    line-height: 50px !important;
    padding-left: 50px !important;
    transition: background-color 0.3s, color 0.3s !important;
  }
  .menuUl .el-menu-item.is-active,
  .el-menu-item:hover {
    background-color: #f1f8ff !important;
  }
  .menuUl .el-menu-item.is-active {
    border-bottom: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
    position: relative;
  }
  .menuUl .el-menu-item.is-active::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 50px;
    background-color: #4286f5;
    left: 0;
    top: -1px;
  }
}
</style>